import validator from 'validator'

export const BookingRequestValidation = (packageForm, errors) => {
  packageForm.slice(1).forEach((el) => {
    if (el.fieldType === 1) {
      if (!el.fieldValue && el.required) {
        Object.assign(errors, { [el.fieldLabel]: 'Name cannot be empty' })
      }
    } else if (el.fieldType === 5) {
      if (!el.fieldValue && el.required) {
        Object.assign(errors, { [el.fieldLabel]: 'Email cannot be empty' })
      } else if (!!el.fieldValue && !validator.isEmail(el.fieldValue)) {
        Object.assign(errors, { [el.fieldLabel]: 'Invalid Email' })
      }
    } else if (el.fieldType === 4) {
      if (!el.fieldValue && el.required) {
        Object.assign(errors, { [el.fieldLabel]: 'Phone number cannot be empty' })
      } else if (!!el.fieldValue && el.fieldValue.length > 50) {
        Object.assign(errors, { [el.fieldLabel]: 'Phone number cannot exceed 50 digits' })
      } else if (!!el.fieldValue && !validator.isMobilePhone(el.fieldValue)) {
        Object.assign(errors, { [el.fieldLabel]: 'Invalid Mobile Phone Number' })
      }
    } else if (el.fieldType === 2) {
      if (!el.fieldValue && el.required) {
        Object.assign(errors, { [el.fieldLabel]: 'Message cannot be empty' })
      } else if (!!el.fieldValue && el.fieldValue.length > 1000) {
        Object.assign(errors, { [el.fieldLabel]: 'Message cannot exceed 1000 characters' })
      }
    }
  })

  return errors
}
